import { apiGet } from "../baseApi";
import { setBuildingData } from "service/mapper";

export const getList = async ({params={}, config = {}}) => {
  try {
    const response = await apiGet("_building", params, null, config);
    return {
      ...response,
      rowData: (Array.isArray(response.data.buildings) ? response.data.buildings : []).map((el) => setBuildingData(el)),
    };
  } catch (error) {
    return Promise.reject(error);
  }
};
